import PaginatedItemsTable from "./PaginatedItemsTable";
/**
 * The SendToModal component is a modal in JavaScript that allows users to select items from a list and
 * confirm their selection.
 * @param props - The `SendToModal` component receives the following props:
 * @returns The `SendToModal` component is being returned. It is a modal component that displays a
 * selection interface with a search input, a select all checkbox, a paginated table of items, and
 * buttons for canceling and confirming the selection. The modal is displayed conditionally based on
 * the `visible` prop.
 */

const SendToModal = (props) => {
  const {
    title,
    visible,
    searchPlaceholderText,
    handleCancel,
    sendTo,
    tableTitle,
    searchQuery,
    setSearchQuery,
    selectAll,
    handleSelectAll,
    filteredItems,
    selectedItems,
    handleItemSelect,
    handleConfirm,
    isLoading = false,
  } = props;

  if (!visible) {
    return null;
  }

  return (
    <div
      className="modal"
      tabIndex={"-1"}
      role="dialog"
      style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content" style={{ minWidth: "700px" }}>
          <div className="modal-header">
            <h1 className="modal-title">Select {title}</h1>
            <button className="close-button" onClick={handleCancel}>
              &times;
            </button>
          </div>
          <div
            className="modal-body"
            style={{ maxHeight: "95vh", overflowY: "auto" }}
          >
            {isLoading ? (
             <div className="loader"></div>
            ) : (
              <>
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder={`Search ${searchPlaceholderText}...`}
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                </div>

                <div style={{ margin: "0px 0" }}>
                  <label>
                    <input
                      type="checkbox"
                      checked={selectAll}
                      onChange={handleSelectAll}
                      style={{ marginRight: "5px" }}
                    />
                    Select All
                  </label>
                </div>

                <PaginatedItemsTable
                  items={filteredItems || []}
                  selectedItems={selectedItems}
                  onItemSelect={handleItemSelect}
                  tableTitle={tableTitle}
                  itemType={sendTo?.id}
                  itemsPerPage={5}
                  searchQuery={searchQuery}
                />
              </>
            )}
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleConfirm}
              disabled={selectedItems.length === 0}
            >
              {" "}
              Confirm{" "}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SendToModal;
